<template>
	<div
		class="fixed inset-0 bg-black/50 flex items-start justify-between z-50 p-4"
		@click.self="closeModal"
	>
		<div
			class="bg-white rounded-3xl w-full mx-auto shadow-lg overflow-hidden mt-24"
			:class="props.isInQuotePage ? 'max-w-2xl' : 'max-w-4xl'"
		>
			<div
				class="flex gap-2 lg:hidden border-b border-slate-100 items-center justify-start px-0 py-2 mx-4"
				v-if="!props.isInQuotePage"
			>
				<button
					class="font-semibold text-sm py-2 rounded-md inline-block px-3 hover:bg-blue-900/[0.05]"
					:class="searchType === 'stocks' ? 'text-primary-600' : 'text-slate-900'"
					@click="searchType = 'stocks'"
				>
					Tickers
				</button>
				<button
					class="font-semibold text-sm py-2 rounded-md inline-block px-3 hover:bg-blue-900/[0.05]"
					:class="searchType === 'posts' ? 'text-primary-600' : 'text-slate-900'"
					@click="searchType = 'posts'"
				>
					Articles
				</button>

				<button
					class="text-slate-400 hover:text-slate-700 ml-auto w-[24px] h-[24px] flex lg:hidden items-center justify-center"
					@click="closeModal"
				>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clip-path="url(#clip0_2212_4922)">
							<path
								d="M5.50317 18.7553L18.6352 5.38458"
								stroke="#94A3B8"
								stroke-width="2"
								stroke-linecap="round"
							/>
							<path
								d="M5.36499 5.24467L18.497 18.6154"
								stroke="#94A3B8"
								stroke-width="2"
								stroke-linecap="round"
							/>
						</g>
						<defs>
							<clipPath id="clip0_2212_4922">
								<rect
									width="15"
									height="16"
									fill="white"
									transform="translate(4.5 4)"
								/>
							</clipPath>
						</defs>
					</svg>
				</button>
			</div>

			<div class="flex items-center gap-3 lg:gap-6 px-4 py-4 justify-between">
				<button
					class="absolute top-4 right-4 text-slate-400 hover:text-slate-700 hidden"
					@click="closeModal"
				>
					Close
				</button>
				<div
					class="relative flex items-center px-4 bg-blue-900/[0.05] rounded-xl w-full"
					:class="props.isInQuotePage ? 'max-w-sm' : 'max-w-lg'"
				>
					<svg
						width="20"
						height="20"
						viewBox="0 0 24 25"
						fill="rgba(129, 136, 152, 1)"
						xmlns="http://www.w3.org/2000/svg"
						class="text-slate-400"
					>
						<path
							d="M10.0799 1.93994C5.56867 1.93994 1.91992 5.58869 1.91992 10.0999C1.91992 14.6112 5.56867 18.2599 10.0799 18.2599C11.6905 18.2599 13.1812 17.7874 14.4449 16.9849L20.3399 22.8799L22.3799 20.8399L16.5599 15.0349C17.6062 13.6624 18.2399 11.9618 18.2399 10.0999C18.2399 5.58869 14.5912 1.93994 10.0799 1.93994ZM10.0799 3.85994C13.5355 3.85994 16.3199 6.64432 16.3199 10.0999C16.3199 13.5556 13.5355 16.3399 10.0799 16.3399C6.6243 16.3399 3.83992 13.5556 3.83992 10.0999C3.83992 6.64432 6.6243 3.85994 10.0799 3.85994Z"
							fill="currentColor"
						/>
					</svg>
					<input
						type="text"
						v-model="searchQuery"
						:placeholder="
							searchType === 'stocks'
								? 'Search for tickers, companies or news'
								: 'Search for articles, posts, news and more'
						"
						class="flex-grow p-2 text-lg bg-white/[0.0] border-none focus:ring-0 outline-none text-black"
						ref="searchInput"
						@keydown="
							(e) => (searchType === 'stocks' ? handleKeydown(e) : onSearch(e))
						"
					/>

					<button
						v-if="searchType === 'posts' && !props.isInQuotePage"
						class="font-semibold text-sm text-white relative -right-3 hover:text-white/[0.8] ml-auto py-2 rounded-lg inline-block px-3 bg-blue-300"
						type="button"
						@click="onSearch({ key: 'Enter' })"
					>
						Search
					</button>
				</div>

				<div
					class="hidden lg:inline-flex gap-2 mr-auto"
					v-if="!props.isInQuotePage"
				>
					<button
						class="font-semibold text-sm ml-auto py-2 rounded-md hidden lg:inline-block px-3 hover:bg-blue-900/[0.05]"
						:class="searchType === 'stocks' ? 'text-primary-600' : 'text-slate-900'"
						@click="searchType = 'stocks'"
					>
						Tickers
					</button>
					<button
						class="font-semibold text-sm ml-auto py-2 rounded-md hidden lg:inline-block px-3 hover:bg-blue-900/[0.05]"
						:class="searchType === 'posts' ? 'text-primary-600' : 'text-slate-900'"
						@click="searchType = 'posts'"
					>
						Articles
					</button>
				</div>

				<button
					v-if="searchQuery.length > 0"
					class="text-primary-600 font-semibold text-sm h-6 ml-auto hidden lg:inline-block"
					@click="searchQuery = ''"
				>
					Clear search
				</button>

				<button
					class="text-slate-400 hover:text-slate-700 w-[24px] h-[24px] hidden lg:flex items-center justify-center"
					@click="closeModal"
				>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clip-path="url(#clip0_2212_4922)">
							<path
								d="M5.50317 18.7553L18.6352 5.38458"
								stroke="#94A3B8"
								stroke-width="2"
								stroke-linecap="round"
							/>
							<path
								d="M5.36499 5.24467L18.497 18.6154"
								stroke="#94A3B8"
								stroke-width="2"
								stroke-linecap="round"
							/>
						</g>
						<defs>
							<clipPath id="clip0_2212_4922">
								<rect
									width="15"
									height="16"
									fill="white"
									transform="translate(4.5 4)"
								/>
							</clipPath>
						</defs>
					</svg>
				</button>
			</div>

			<!-- RESULTS LIST -->
			<div
				class="max-h-[400px] overflow-y-auto p-2 no-scroll-on-focus"
				v-if="searchType === 'stocks'"
				ref="resultsContainer"
				tabindex="0"
				@keydown.capture.stop.prevent="
					(e) => {
						if (e.key === 'ArrowDown' || e.key === 'ArrowUp') e.preventDefault();
					}
				"
			>
				<template v-if="results.length > 0">
					<button
						v-for="(item, index) in results"
						:key="(item as StockResults).symbol"
						:data-result-index="index"
						tabindex="-1"
						@click="
							handleNavigation(
								`/quote/${(item as StockResults).symbol.toUpperCase()}/`
							)
						"
						class="flex items-center p-3 hover:bg-blue-900/[0.05] border border-white focus:bg-blue-900/[0.05] rounded-md cursor-pointer w-full text-left"
					>
						<span
							v-if="failedImages.has((item as StockResults).symbol)"
							class="w-10 h-10 rounded-md mr-4 flex items-center justify-center text-white text-sm font-medium"
							style="background-color: #222"
						>
							{{ (item as StockResults).symbol }}
						</span>
						<img
							v-else
							:src="`https://stt-ts-resources.s3.us-east-1.amazonaws.com/stock-symbols/${(item as StockResults).symbol}`"
							:alt="`Logo image for ${(item as StockResults).symbol}`"
							class="w-10 h-10 rounded-md object-cover mr-4 bg-slate-100/[.2]"
							@error="handleImageError((item as StockResults).symbol)"
						/>
						<div class="flex-grow text-left">
							<p class="font-semibold text-slate-800 text-sm mb-0 leading-none">
								{{ (item as StockResults).longName }}
							</p>
							<span class="text-xs text-slate-500">
								({{ (item as StockResults).symbol }})
							</span>
						</div>
						<p class="text-xs text-slate-500">
							{{ (item as StockResults).exchange }}
						</p>
					</button>
				</template>

				<div
					class="flex flex-col gap-4 justify-center"
					v-else
				>
					<img
						src="/images/icons/type_machine.svg"
						alt="No results"
						class="w-40 h-32 rounded-md object-contain mx-auto"
					/>

					<p class="font-semibold text-slate-800 text-lg text-center">
						What are you looking for?
					</p>
				</div>

				<div class="h-[80px]"></div>
			</div>

			<div
				class="px-6 py-8 flex items-center gap-4 relative"
				v-if="searchType === 'stocks'"
			>
				<div
					class="h-[80px] bg-gradient-to-b top-[-64px] mx-auto left-0 right-0 to-white w-full absolute from-white/[0.0] pointer-events-none"
				></div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
type StockResults = { symbol: string; longName: string; exchange: string };
type PostResults = {
	image: string;
	title: string;
	slug: string;
	post_type: string;
};

const props = defineProps<{
	closeModal: (e: Event) => void;
	results: Array<StockResults | PostResults>;
	onType: (q: string) => void;
	isInQuotePage?: boolean;
	defaultSearchType?: string;
}>();

const searchQuery = ref("");
const failedImages = ref(new Set<string>());
const searchInput = ref<HTMLInputElement | null>(null);
const resultsContainer = ref<HTMLDivElement | null>(null);
const focusedIndex = ref(-1);
const searchType = ref(props.defaultSearchType || "stocks");

// --- SCROLL LOCK (prevents list from moving on ↑/↓) ---
let rafId = 0 as number;

const lockContainerScrollFor = (ms = 160) => {
	const el = resultsContainer.value;
	if (!el) return;

	const top = el.scrollTop;
	const start = performance.now();

	cancelAnimationFrame(rafId);

	const loop = (t: number) => {
		if (!resultsContainer.value) return;
		resultsContainer.value.scrollTop = top;
		if (t - start < ms) {
			rafId = requestAnimationFrame(loop);
		}
	};
	rafId = requestAnimationFrame(loop);
};

// Focus input when component mounts
onMounted(() => {
	nextTick(() => {
		searchInput.value?.focus();
	});

	// Global guard to suppress any accidental arrow scrolls behind the scenes
	const keyguard = (e: KeyboardEvent) => {
		if (e.key === "ArrowDown" || e.key === "ArrowUp") {
			e.preventDefault();
		}
	};
	window.addEventListener("keydown", keyguard, { passive: false });

	onBeforeUnmount(() => {
		window.removeEventListener("keydown", keyguard);
		cancelAnimationFrame(rafId);
	});
});

watch(searchQuery, (q, _) => {
	if (!q) {
		focusedIndex.value = -1;
		return null;
	} else {
		props.onType(q);
	}
});

// Force stocks mode when in quote page
watch(
	() => props.isInQuotePage,
	(isInQuotePage) => {
		if (isInQuotePage) {
			searchType.value = "stocks";
		}
	},
	{ immediate: true }
);

const onSearch = (e: KeyboardEvent | { key: string }) => {
	// Escape: close search if you manage a showSearch flag elsewhere
	// if ((e as KeyboardEvent).key === "Escape") return (showSearch.value = false);

	if (e.key === "Enter") {
		const searchValue = searchQuery.value;

		if (searchValue && searchValue.trim() !== "") {
			window.location.href = `/blog/?search=${encodeURIComponent(searchValue)}`;
			// if you manage a modal flag, close it here
			// showSearch.value = false;
		}
	}
};

// Handle keyboard navigation
const handleKeydown = (event: KeyboardEvent) => {
	if (event.key === "Enter") {
		if (props.results.length > 0) {
			event.preventDefault();

			if (focusedIndex.value === -1) {
				lockContainerScrollFor();
				focusedIndex.value = 0;
				updateFocus();
			} else {
				const targetButton = document.querySelector(
					`[data-result-index="${focusedIndex.value}"]`
				) as HTMLButtonElement | null;
				targetButton?.click();
			}
		}
	} else if (event.key === "ArrowDown") {
		event.preventDefault();
		if (props.results.length > 0) {
			lockContainerScrollFor();
			focusedIndex.value = Math.min(
				focusedIndex.value + 1,
				props.results.length - 1
			);
			updateFocus();
		}
	} else if (event.key === "ArrowUp") {
		event.preventDefault();
		lockContainerScrollFor();
		focusedIndex.value = Math.max(focusedIndex.value - 1, -1);
		updateFocus();
	}
};

const updateFocus = () => {
	// Remove focus from all result buttons
	document.querySelectorAll("[data-result-index]").forEach((btn) => {
		btn.classList.remove("focused");
	});

	// Add focus class to the current item (no scrolling)
	if (focusedIndex.value >= 0) {
		const focusedButton = document.querySelector(
			`[data-result-index="${focusedIndex.value}"]`
		) as HTMLButtonElement | null;
		focusedButton?.classList.add("focused");
	}
};

const handleImageError = (symbol: string) => {
	failedImages.value.add(symbol);
};

const handleNavigation = (path: string) => {
	document.body.style.overflow = "";
	props.closeModal(new Event("click"));
	// Nuxt navigate helper
	// @ts-ignore
	navigateTo(path);
};
</script>

<style scoped lang="scss">
@use "~/assets/utils.scss" as *;

/* Focus styling to match hover but avoid layout shift (no border) */
button[data-result-index].focused {
	background-color: rgba(30, 58, 138, 0.05) !important;
	outline: 2px solid $blue-300 !important;
	outline-offset: -2px;
}

/* Prevent automatic scroll anchoring & chaining */
.no-scroll-on-focus {
	overflow-anchor: none;
	scroll-behavior: auto;
	overscroll-behavior: contain;

	/* Make scrollbar thumb transparent */
	scrollbar-color: transparent transparent;
	scrollbar-width: thin;

	&::-webkit-scrollbar {
		width: 8px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}

	&::-webkit-scrollbar-thumb {
		background: transparent;
		border-radius: 4px;
	}
}

/* Prevent buttons from triggering scroll */
button[data-result-index] {
	scroll-margin: 0;
}
</style>
